import { AtlasCaption } from '@justomx/atlas-components'

import { StackAtom } from 'components/atoms/Stack.atom'
import noDataLogo from '../../assets/images/no-data.png'

interface NoDataMoleculeProps {
  padding?: string
}

export const NoDataMolecule = (props: NoDataMoleculeProps) => {
  const { padding } = props

  return (
    <StackAtom
      $justify="center"
      $align="center"
      $gap={16}
      $direction="column"
      $padding={padding}
    >
      <img src={noDataLogo} alt="no-data-img" width={195} height={160} />
      <AtlasCaption>No hay información para mostrar</AtlasCaption>
    </StackAtom>
  )
}
